'use strict';

const formValidation = require('../components/formValidation');
const formHandling = require('../formHandling/syncSameFieldsInForm');
const conditionalRequired = require('../formHandling/conditionalRequired');
const { alertMessage } = require('../common/common');

const location = window.location;

function setRequired(elements) {
    document.querySelectorAll(elements).forEach((el) => {
        el.classList.add('required');
        el.querySelector('input, textarea').setAttribute('required', '');
        el.querySelector('input, textarea').setAttribute('aria-required', 'true');
    });
}

function removeRequired(elements) {
    document.querySelectorAll(elements).forEach((el) => {
        el.classList.remove('required');
        el.querySelector('input, textarea').removeAttribute('required');
        el.querySelector('input, textarea').removeAttribute('aria-required');
    });
}

function setDisabledHidden(elements) {
    document.querySelectorAll(elements).forEach((el) => {
        el.classList.add('d-none');
        el.querySelector('input, textarea, select').setAttribute('disabled', '');
        el.querySelector('input, textarea').value = '';
    });
}

function removeDisabledHidden(elements) {
    document.querySelectorAll(elements).forEach((el) => {
        el.classList.remove('d-none');
        el.querySelector('input, textarea, select').removeAttribute('disabled');
    });
}

module.exports = {
    init: function () {
        formHandling.init();
        conditionalRequired.init();
    },
    submitProfile: function () {
        $('form.edit-profile-form').on('submit', function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $form.spinner().start();
            $('form.edit-profile-form').trigger('profile:edit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        formValidation($form, data);
                    } else {
                        alertMessage(data.msg, 'cc-alert--success');
                    }
                    if ($('#billingBirthday').val().trim() !== ''){
                        $('#birthdate-mask').prop("disabled",true);
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    },

    submitContactForm: function () {
        $('form.contact-form').on('submit', function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $form.spinner().start();
            $('form.contact-form').trigger('contact:edit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        formValidation($form, data);
                        if (data.msg) {
                            alertMessage(data.msg, 'cc-alert--danger');
                        }
                    } else {
                        alertMessage(data.msg, 'cc-alert--success');
                        $('.submit-btn').addClass('cc-disabled');
                        $('.submit-btn').prop("disabled",true);
                        setTimeout(() => {
                            location.href = data.redirectUrl;
                          },3000);
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    },

    submitPassword: function () {
        $('form.change-password-form').on('submit', function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $form.spinner().start();
            $('form.change-password-form').trigger('password:edit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    if (!data.success) {
                        $form.spinner().stop();
                        formValidation($form, data);
                        if (data.fields.dwfrm_profilePassword_login_currentpassword  != undefined) {
                            $('.js-current-password .cc-message').addClass('cc-message--visible').text(data.fields.dwfrm_profilePassword_login_currentpassword);              
                        }
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    },

    //PWC-NOA-449 add function for handle contact form beahaviour
    changeContactFormBeahaviour: function () {
        const urlParams = new URLSearchParams(document.location.search);
        const paramReasonValue = urlParams.get('thema');
        const hasParamContractRevocation = urlParams.has("thema") && paramReasonValue === 'vertragswiderruf';
        const select = document.getElementById("reasonSelect");
        const selectIndex = select ? Array.from(select.options).findIndex(option => option.id === 'contact.reason.contract.revocation.subject') : false;
        const issueRelatedOrderBtn = document.getElementById("issueRelatedOrderYes");
        const selectBoxBtn = document.querySelector('.js-contact-reason button');
        const textareaMessageTextarea = document.querySelector('.js-contact-message textarea');
        const textareaMessageCompletelyValue = textareaMessageTextarea ? textareaMessageTextarea.getAttribute('data-withdraw-contract-completely-text') : false;
        const textareaMessagePartiallyValue = textareaMessageTextarea ? textareaMessageTextarea.getAttribute('data-withdraw-contract-partially-text') : false;
        const radioWithdrawContractCompletely = document.querySelector('.js-withdraw-contract-completely');
        const radioWithdrawContractPartially = document.querySelector('.js-withdraw-contract-partially');

        if (select) {
            select.addEventListener('change', () => {
                if (select.options.selectedIndex === selectIndex) {
                    setRequired('.js-firstname, .js-lastname, .js-order-number');
                    removeRequired('.js-contact-message');
                    setDisabledHidden('.js-customer-number');
                    removeDisabledHidden('.js-order-number, .js-firstname, .js-lastname, .js-withdraw-contract');

                    issueRelatedOrderBtn.click();
                    radioWithdrawContractCompletely.click();

                    textareaMessageTextarea.value = textareaMessageCompletelyValue;
                    textareaMessageTextarea.setAttribute('disabled', '');

                    $('body').trigger('formValidation:revalidate', '.js-contact-form');

                } else {
                    removeRequired('.js-firstname, .js-lastname, .js-order-number');
                    setRequired('.js-contact-message');

                    textareaMessageTextarea.value = '';
                    textareaMessageTextarea.removeAttribute('disabled');

                    setDisabledHidden('.js-firstname, .js-lastname, .js-withdraw-contract, .js-contact-message-item-number, .js-order-number');

                    if (document.querySelector('#issueRelatedOrderNo').checked) {
                        setDisabledHidden('.js-customer-number');
                    } else {
                        removeDisabledHidden('.js-customer-number, .js-order-number');
                    }

                    $('body').trigger('formValidation:revalidate', '.js-contact-form');
                }
            });
        }


        /**
         * Handles the contract revocation flow by selecting the configured contact reason,
         * unless the contract revocation parameter is missing or the current country is Switzerland.
         * @return {Promise<void>}
         */
        async function handleContractRevocationFlow() {
            if (!hasParamContractRevocation || window.spsDataLayer.internal.global.currentCountry === 'CH') {
                return;
            }

            // 1. Click the first button
            await clickWhenReady(() => issueRelatedOrderBtn);

            // 2. Wait until the button is actually generated and is existing.
            const existingSelectBoxBtn = await waitForElement(() =>
                document.querySelector('.js-contact-reason button')
            );

            await openSelectAndWait(existingSelectBoxBtn);

            // 3. Search for the option only AFTER opening and click it
            const option = await waitForElement(() =>
                document.getElementById(`bs-select-1-${selectIndex}`)
            );

            // 4. Click the option
            option.click();

            // 5. Remove focus
            selectBoxBtn.blur();
        };

        /**
         * Opens a Bootstrap select element and waits until its dropdown is visible and ready.
         * @param {HTMLElement} selectBoxBtn bootstrap generated button for select boxes 
         * @return {Promise<void>}
         */
        async function openSelectAndWait(selectBoxBtn) {
            const selectWrapper = selectBoxBtn.closest('.bootstrap-select');
            selectBoxBtn.click();

            if (selectWrapper) {
                await waitForCondition(() => {
                    // Prove that it doesn't just exist in the DOM, but is also actually clickable.
                    return (
                        selectWrapper.classList.contains('show') ||
                        selectWrapper.querySelector('.dropdown-menu.show')
                    );
                });
            }
        };

        /**
         * Waits until the provided element exists and is clickable, then clicks it.
         * @param {function} getElement it is an HTML element that can be clicked.
         * @return {Promise<HTMLElement>}
         */
        async function clickWhenReady(getElement) {
            const element = await waitForElement(getElement);
            element.click();
            return element;
        };

        /**
         * Waits until the provided getter returns an element that is connected and clickable.
         * @param {function} getElement is an HTML element
         * @return {Promise<HTMLElement>}
         */
        function waitForElement(getElement) {
            return new Promise((resolve) => {
                const element = getElement();

                if (isClickable(element)) {
                    resolve(element);
                    return;
                }

                const observer = new MutationObserver(() => {
                    const element = getElement();

                    if (isClickable(element)) {
                        observer.disconnect();
                        resolve(element);
                    }
                });

                observer.observe(document.body, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: [
                        'class',
                        'disabled',
                        'aria-disabled',
                        'aria-expanded'
                    ]
                });
            });
        };

        /**
         * Waits until the provided condition returns true.
         * @param {function} conditionFn a function for verification
         * @return {Promise<void>}
         */
        function waitForCondition(conditionFn) {
            return new Promise((resolve) => {
                if (conditionFn()) {
                    resolve();
                    return;
                }

                const observer = new MutationObserver(() => {
                    if (conditionFn()) {
                        observer.disconnect();
                        resolve();
                    }
                });

                observer.observe(document.body, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: [
                        'class',
                        'disabled',
                        'aria-disabled',
                        'aria-expanded'
                    ]
                });
            });
        };

        /**
         * Checks whether an element is connected, visible, enabled, and can receive pointer events.
         * @param {HTMLElement} element is an HTML element for check
         * @return {boolean}
         */
        function isClickable(element) {
            if (!element || !element.isConnected) {
                return false;
            }

            // Prove that it doesn't just exist in the DOM, but is also actually clickable.
            const style = window.getComputedStyle(element);
            const rect = element.getBoundingClientRect();

            return (
                style.display !== 'none' &&
                style.visibility !== 'hidden' &&
                style.pointerEvents !== 'none' &&
                rect.width > 0 &&
                rect.height > 0 &&
                !element.disabled &&
                element.getAttribute('aria-disabled') !== 'true'
            );
        };

        handleContractRevocationFlow();

        if (radioWithdrawContractCompletely) {
            radioWithdrawContractCompletely.addEventListener('change', () => {
                textareaMessageTextarea.value = textareaMessageCompletelyValue;
                removeRequired('.js-contact-message-item-number');
                setDisabledHidden('.js-contact-message-item-number');

                $('body').trigger('formValidation:revalidate', '.js-contact-form');
                
            });
        }

        if (radioWithdrawContractPartially) {
            radioWithdrawContractPartially.addEventListener('change', () => {
                textareaMessageTextarea.value = textareaMessagePartiallyValue;
                setRequired('.js-contact-message-item-number');
                removeDisabledHidden('.js-contact-message-item-number');

                $('body').trigger('formValidation:revalidate', '.js-contact-form');
            });
        }
        
        //PWC-NOA-449 if is related to order, show all div
        $('#issueRelatedOrderYes').on('change', function () {
            const $el = $(this);
            if ($el.is(":checked")) {
                removeDisabledHidden('.js-order-number, .js-contact-reason, .js-contact-message');
                
                if (select.options.selectedIndex !== selectIndex) {
                    $('.js-customer-number').removeClass('d-none');
                    removeDisabledHidden('.js-customer-number');
                }

                $('.js-contact-captcha').removeClass('d-none');
                $('.js-contact-data-protection').removeClass('d-none');

                $('body').trigger('formValidation:revalidate', '.js-contact-form');
            }
        });
        //PWC-NOA-449 if is NOT related to order, hide orders div
        $('#issueRelatedOrderNo').on('change', function () {
            const $el = $(this);
            if ($el.is(":checked")) {
                setDisabledHidden('.js-order-number, .js-customer-number');
                removeDisabledHidden('.js-contact-reason, .js-contact-message');

                $('.js-contact-captcha').removeClass('d-none');
                $('.js-contact-data-protection').removeClass('d-none');

                if (select.options.selectedIndex === selectIndex) {
                    selectBoxBtn.click();
                    // back to selection "Bitte wählen"
                    document.getElementById('bs-select-1-0').click();
                }

                $('body').trigger('formValidation:revalidate', '.js-contact-form');
            }
        });
    },

    //PWC-NOA-440 add function for submit the change mail form
    submitChangeMail: function () {
        $('form.change-mail-form').on('submit', function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $form.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    if (!data.success) {
                        $form.spinner().stop();
                        formValidation($form, data);
                        if (data.fields.dwfrm_profilePassword_login_currentpassword  != undefined) {
                            $('.js-current-password .cc-message').addClass('cc-message--visible').text(data.fields.dwfrm_profilePassword_login_currentpassword);              
                        }
                        if (data.msg) {
                            alertMessage(data.msg, 'cc-alert--danger');
                        }
                    } else {
                        //PWC-NOA-440 if modify mail is correct, redirect to account show
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    },

    //PWC-NOA-439 function that manage flow of resend email DOI Newsletter
    submitResendDOINL: function () {
        $('.btn-resend-doi-nl').on('click', function (e) {
            e.preventDefault();
            $('body').spinner().start();
            var url = $(this).data('url');
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    if (data && data.success) {
                        $('body').spinner().stop();
                        alertMessage(data.message, 'cc-alert--success');
                    } else {
                        $('body').spinner().stop();
                        alertMessage(data.message, 'cc-alert--danger');
                    }
                },
                error: function (err) {
                    if (data && !data.success) {
                        alertMessage(data.message, 'cc-alert--danger');
                    } 
                    $('body').spinner().stop();
                }
            });
        });
       },

    //PWC-NOA-553 manage submit of club consent submit in loyalty section
    submitClubConsentMembership: function () {
        $('form.edit-club-form').on('submit', function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $form.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    if (data && data.success) {
                        $form.spinner().stop();
                        alertMessage(data.message, 'cc-alert--success');
                        setTimeout(() => {
                            location.href = data.redirectUrl;
                          },1000);
                    } else {
                        $form.spinner().stop();
                        alertMessage(data.message, 'cc-alert--danger');
                    }
                },
                error: function (err) {
                    if (data && !data.success) {
                        alertMessage(data.message, 'cc-alert--danger');
                    }
                    $form.spinner().stop();
                }
            });
        });
    }
}; 